"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logos = void 0;
var logo_primary_updated_png_1 = __importDefault(require("./assets/logo_primary_updated.png"));
var logo_secondary_updated_png_1 = __importDefault(require("./assets/logo_secondary_updated.png"));
exports.logos = {
    dark: {
        img: logo_primary_updated_png_1.default,
        background: "bg-[#FFFFFF]",
        boxShadow: "shadow-[0px_4px_14px_0px_#00000026]",
    },
    light: {
        img: logo_secondary_updated_png_1.default,
        background: "bg-transparent",
    },
};
